export default {
  generalEmailSettings: {
    title: 'General Email Settings',
    errorLoading: 'Error loading general email configuration.',
    extractOriginalFrom: {
      label: 'Extract original From address (Google Groups)',
      tooltip:
        "For emails forwarded by services like Google Groups, this attempts to extract the original sender's 'From' address if it was modified by the forwarding service.",
    },
    supervisorSendAs: {
      label: 'Allow supervisors to send emails as other adjusters',
      tooltip:
        'Allow supervisors to send emails as other adjusters in their organization. When disabled, supervisors can only send emails as themselves.',
    },
    restrictSendAs: {
      label: "Restrict 'Send As' to managed users only",
      tooltip:
        'When enabled, supervisors can only send emails as users they directly or indirectly manage. When disabled, supervisors can send as any active adjuster in the organization.',
    },
    personalEmailSignature: {
      label: 'Allow users to set a personal email signature',
      tooltip:
        'When enabled, each user can set their own email signature from the user menu, and it replaces the organization signature on emails they send. When disabled, everyone sends with the organization signature and any signature a user already saved is ignored.',
    },
    htmlAttachments: {
      label: 'Allow HTML attachments in emails',
      tooltip:
        'When enabled, this organization can send and receive .html and .htm email attachments. HTML attachments are always downloaded, never previewed in the app. When disabled, they are rejected on upload, and one that arrives on an incoming email is listed as blocked and cannot be opened.',
    },
  },
} as const;
